import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { storeStateDetailsSchema } from '@apple/features/store/models/budget';

export function useRetailStore(storeCode: string) {
	const storeQuery = useQuery({
		queryKey: ['store', storeCode],
		queryFn: async () => {
			const response = await axios.get<unknown>(`/api/stores/${storeCode}/state`);
			return storeStateDetailsSchema.parse(response.data);
		},
		staleTime: Infinity,
		placeholderData: keepPreviousData,
		select: x => ({
			...x,
			remainingBudget: x.allocatedAmount - x.consumedAmount - x.pendingAmount,
		}),
	});

	return {
		storeQuery,
	};
}
